import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from 'react-tooltip';
import { offset } from '@floating-ui/dom';
import ResetFieldButton from '../buttons/ResetFieldButton';
import './_styles_/Field.css';
import { resolveIsChanged, resolveOnReset } from '../../utils/fields';
import { NO_STATE } from '../../hooks/useExtendedState';
import { extendedStateType } from '../../types';

Field.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    label: PropTypes.node,
    icon: PropTypes.string,
    iconTooltip: PropTypes.string,
    iconMiddlewares: PropTypes.arrayOf(PropTypes.shape({ offset: PropTypes.shape({ mainAxis: PropTypes.number, crossAxis: PropTypes.number }) })),
    error: PropTypes.string,
    inputId: PropTypes.string,
    postfix: PropTypes.node,
    onReset: PropTypes.func,
    isChanged: PropTypes.bool,
    isRequired: PropTypes.bool,
    // when true, indicates the required field is currently empty -> show error border
    isRequiredEmpty: PropTypes.bool,
    disabled: PropTypes.bool,
    state: extendedStateType,
};

function Field(props) {
    const {
        label = null,
        className = '',
        icon = null,
        iconTooltip = null,
        iconMiddlewares = [offset(10)],
        postfix = null,
        children,
        error = null,
        inputId = null,
        onReset,
        isChanged,
        isRequired = false,
        isRequiredEmpty = false,
        disabled = false,
        state = NO_STATE,
    } = props;
    const resolvedOnReset = resolveOnReset(onReset, state);
    const resolvedIsChanged = resolveIsChanged(isChanged, state);
    return (
        <div className={['field-container', className].filter(Boolean).join(' ')}>
            <div className={`field${error ? ' error' : ''}${resolvedIsChanged ? ' modified' : ''}${isRequired ? ' required' : ''}${isRequiredEmpty ? ' required-empty' : ''}${disabled ? ' disabled' : ''}`}>
                {label && (
                    <label className="field--key" htmlFor={inputId}>{label}{icon && (
                        <>
                            &nbsp;&nbsp;
                            <FontAwesomeIcon data-tooltip-id={`tooltip-${inputId}`} className="tooltip-icon" icon={icon} tabIndex={-1} />
                            {iconTooltip && <Tooltip id={`tooltip-${inputId}`} content={iconTooltip} place="down" className="login-tooltip" opacity={1} middlewares={iconMiddlewares} noArrow />}
                        </>
                    )}
                    </label>
                )}
                <div className="field--value">{children}{postfix}</div>
                {error && <div className="validation-error">{error}</div>}
            </div>
            {resolvedIsChanged && resolvedOnReset && <ResetFieldButton onReset={resolvedOnReset} />}
        </div>
    );
}

export default memo(Field);
